import {OfferPrice} from '@daedalus/core/src/offer/types/offer'

export const addStringNumbers = (num1: string, num2: string) => {
  return parseFloat(num1) + parseFloat(num2)
}

/**
 * This is a temporary logic for summing up prices for Lite split booking solution
 * to avoid summing up proces for two separate bookings on backend side. This should be removed
 * when BoVIO will bundle two bookings together with calculated total price.
 *
 * Sums all components of two given sets of OfferPrice arrays
 * @param prices - Array of OfferPrices
 * @returns combined set of two
 */
export const sumBookingPrices = (prices: OfferPrice[][]) => {
  if (prices.length > 1) {
    const price1 = prices[0][0]
    const price2 = prices[1][0]

    return [
      {
        ...price1,
        chargeable: {
          ...price1.chargeable,
          base: price1.chargeable.base + price2.chargeable.base,
          taxes: price1.chargeable.taxes + price2.chargeable.taxes
        },
        hotelFees: {
          breakdown: (() => {
            const breakdown1 = price1.hotelFees.breakdown || []
            const breakdown2 = price2.hotelFees.breakdown || []
            //groupping two sets of breakdown elements by their type, summing the total value
            const result = breakdown1
              .concat(breakdown2)
              .reduce<{resort_fee?: number; tax?: number; other?: number}>(
                (acc, cur) => {
                  return {
                    ...acc,
                    [cur.type]:
                      (acc[cur.type] || 0) + parseFloat(String(cur.total))
                  }
                },
                {}
              )

            return Object.entries(result).map(([type, value]) => ({
              type,
              total: value
            }))
          })(),
          currency: price1.hotelFees.currency,
          total: price1.hotelFees.total + price2.hotelFees.total
        }
      }
    ]
  }

  return prices[0]
}
